import { manager } from '../api/SessionManager';

export const useManagedSession = () => {
    return manager.useSession();
};

export const useManagedStatus = () => {
    return manager.useStatus();
};
